import React from 'react';
import {
  FDTable,
  FDTableCell, FDTableHead, FDTableRow, FDTableBody, FDBodyText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import DeleteButton from 'Components/ComponentLibrary/Atoms/Buttons/DeleteButton';

const AgentOnboardingCapacityTable = ({
  deleteOnboardingCapacityItem,
  submitting,
}) => {
  const { resource } = useMetaLayoutContext();
  const fields = resource.attr('items')?.meta()?.template()?.list()
    ?.filter(field => field.attr('hidden') === false);

  return (
    <FDTable>
      <FDTableHead>
        <FDTableRow>
          {fields?.map(field => <FDTableCell key={field.attr('name')}>{field.attr('prompt')}</FDTableCell>)}
          <FDTableCell key={'delete'} />
        </FDTableRow>
      </FDTableHead>
      <FDTableBody>
        {resource.attr('items')?.resources()?.list()?.map((item) => (
          <FDTableRow key={item.id()}>
            {fields?.map(field => (
              <FDTableCell key={field.attr('name')}>
                <FDBodyText value={item.attr(field.attr('name')) === '' ? '--' : item.attr(field.attr('name'))} />
              </FDTableCell>
            ))}
            <FDTableCell key={'delete'}>
              {item.meta().canDelete() ? <DeleteButton size={'small'} disabled={submitting} onClick={async () => { await deleteOnboardingCapacityItem(item); }} /> : null}
            </FDTableCell>
          </FDTableRow>
        ))}
      </FDTableBody>
    </FDTable>
  );
};


export default AgentOnboardingCapacityTable;
